import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import SideNav from '../sidenav';
import { ReactComponent as Logo } from '$/assets/BixLogo.svg';
import { ReactComponent as InvertedLogo } from '$/assets/logo-inverted.svg';
import { ReactComponent as LogoutIcon } from '$/assets/icons/Logout.svg';
import { ReactComponent as SettingsIcon } from '$/assets/icons/settings.svg';
import * as Bixby from '$/core';
import SearchBox from '../searchBox';
import { History } from '$/services';
import './index.scss';

export interface ITopNavProps {
  welcomeMessage?: string;
  feedbackUrl?: string;
  showAdminLink: boolean;
  onAdminPortal: boolean;
  onSearchChange?: (searchText: string) => void | Promise<void>;
  searchResults?: Bixby.Models.SearchResult[];
  onSearchResultsClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;
  contactUsLink?: string;
  featureFlags?: string[];
}

const TopNav: React.FC<ITopNavProps> = props => {
  const {
    welcomeMessage,
    feedbackUrl,
    showAdminLink,
    onAdminPortal,
    onSearchChange,
    searchResults,
    onSearchResultsClick,
    contactUsLink,
  } = props;
  const featureFlags: string[] = props.featureFlags || [];
  const isStandAlone = Bixby.Configuration.isStandAloneMode;
  const pathForRedirectOnAuth = isStandAlone ? '/portfolio' : '/admin';
  const [menuOpen, setMenuOpen] = useState(false);

  History.listen(() => setMenuOpen(false));

  const menuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleFeedbackAction = () => {
    window.open(feedbackUrl);
  };

  return (
    <div className={classNames('topNav', { active: menuOpen, invert: onAdminPortal })}>
      <Link to={pathForRedirectOnAuth} className="logo_wrap">
        {onAdminPortal && <InvertedLogo />}
        {!onAdminPortal && <Logo />}
      </Link>
      <div className="search_export_combo">
        <SearchBox
          placeholder="Search for Companies"
          onChange={onSearchChange}
          searchResults={searchResults}
          onResultsClick={onSearchResultsClick}
        />
        {showAdminLink && (
          <Link className="nav_portal" to="/admin">
            Admin Portal
          </Link>
        )}
      </div>
      {welcomeMessage && <div className="welcome_message">{welcomeMessage}</div>}
      {isStandAlone && (
        <Link to="/settings" className="top_settings">
          <div className="settings_icon">
            <SettingsIcon />
          </div>
          Settings
        </Link>
      )}
      <Link to="/logout" className="top_logout">
        <div className="logout_icon">
          <LogoutIcon />
        </div>
        Logout
      </Link>
      {isStandAlone && (
        <button role="link" onClick={handleFeedbackAction} className="feedback_item">
          Send Feedback
        </button>
      )}
      <div className="burger_wrap" onClick={menuToggle} />
      <SideNav featureFlags={featureFlags} onAdminPortal={onAdminPortal} contactUsLink={contactUsLink} />
    </div>
  );
};

export default TopNav;
